<div
	class="c-portlet o-block u-width-100p _u-width-100p u-shadow-mini u-bg-primary {{ sectionclass }}_portlet"
	style="position: relative"
>
	<app-loader [showLoader]="showLoad"></app-loader>
	<div
		class="c-portlet__header o-stack o-stack--center o-stack--splitted u-border-bottom u-px-small u-py-mini c-portlet-gap u-border-bottom custom-primary"
		style="position: relative"
	>
		<div class="o-stack__cell">
			<h5>
				{{ sectiontitle }}
				<span
					*ngIf="(tableConfig.enableDownload || downloadConfiguration.enableDownload) && hasData"
					class="datatable-icon"
				>
					<a
						href="javascript:void(0)"
						class="datatable_download_icon r6_datatable_download_icon"
						(click)="downloadCSV($event)"
						target="_blank"
					>
						<img *ngIf="downloadIcon" class="download-icon-svg" src="{{ downloadIcon }}" />
						<i class="fa fa-download" aria-hidden="true" *ngIf="!tableConfig.downloadPNGIcon && !downloadIcon"></i>
						<img
							*ngIf="tableConfig.downloadPNGIcon && !downloadIcon"
							class="download-icon-svg"
							src="../../../../../assets/images/Download_Icon_R7.svg"
						/>
					</a>
				</span>
			</h5>
		</div>
	</div>
	<div class="analytics-portlet-content {{ sectionclass }}">
		<ngx-datatable
			class="datatable ctv_platform_table"
			[rows]="dataTableObj.data"
			[sortType]="'single'"
			[cssClasses]="cssClasses"
			[columnMode]="'force'"
			[headerHeight]="50"
			[footerHeight]="50"
			[rowHeight]="'auto'"
			[limit]="10"
			(sort)="onSort($event)"
			[reorderable]="reorderable"
			(page)="onPageChange($event)"
			[messages]="{ emptyMessage: nodatamessage ? nodatamessage : 'No data to display' }"
		>
			<ngx-datatable-column
				name="Platform"
				[cellClass]="'domain'"
				[headerClass]="'ctvPlatformHeader'"
				[comparator]="platformComparator"
				[resizeable]="false"
			>
				<ng-template let-colHeader="column" let-sort="sortFn" ngx-datatable-header-template>
					<span (click)="sort()" class="cursorPointer">
						{{ firstColumnName ? firstColumnName : 'App' }}
					</span>
				</ng-template>
				<ng-template let-row="row" let-column="column" ngx-datatable-cell-template>
					<div class="network-logo" [ngStyle]="{ 'background-image': 'url(' + row['logo_path'] + ')' }"></div>
					<div class="network-name" [title]="row['platform_name']">{{ row['platform_name'] }}</div>
				</ng-template>
			</ngx-datatable-column>
			<ngx-datatable-column name="Impressions" [comparator]="impressionsComparator" [resizeable]="false">
				<ng-template let-colHeader="column" let-sort="sortFn" ngx-datatable-header-template>
					<span (click)="sort()" class="cursorPointer"> Impressions </span>
				</ng-template>
				<ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
					<div class="other-stats" [title]="row['formatted_impressions']">{{ row['formatted_impressions'] }}</div>
				</ng-template>
			</ngx-datatable-column>
			<ngx-datatable-column name="twentyfivepercent" [comparator]="percent25Comparator" [resizeable]="false">
				<ng-template let-colHeader="column" let-sort="sortFn" ngx-datatable-header-template>
					<span (click)="sort()" class="cursorPointer"> 25% Completed </span>
				</ng-template>
				<ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
					<div class="other-stats" [title]="row['formatted_25_completions_rate']">
						{{ row['formatted_25_completions_rate'] }}
					</div>
				</ng-template>
				<ng-template let-colHeader="column" let-sort="sortFn" ngx-datatable-header-template>
					<span class="datatable-header-cell-wrapper">
						<span (click)="sort()" class="cursorPointer"> 25% Completed </span>
					</span>
				</ng-template>
			</ngx-datatable-column>
			<ngx-datatable-column name="fiftypercent" [comparator]="percent50Comparator" [resizeable]="false">
				<ng-template let-colHeader="column" let-sort="sortFn" ngx-datatable-header-template>
					<span (click)="sort()" class="cursorPointer"> 50% Completed </span>
				</ng-template>
				<ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
					<div class="other-stats" [title]="row['formatted_50_completions_rate']">
						{{ row['formatted_50_completions_rate'] }}
					</div>
				</ng-template>
				<ng-template let-colHeader="column" let-sort="sortFn" ngx-datatable-header-template>
					<span class="datatable-header-cell-wrapper">
						<span (click)="sort()" class="cursorPointer"> 50% Completed </span>
					</span>
				</ng-template>
			</ngx-datatable-column>
			<ngx-datatable-column name="seventyfivepercent" [comparator]="percent75Comparator" [resizeable]="false">
				<ng-template let-colHeader="column" let-sort="sortFn" ngx-datatable-header-template>
					<span (click)="sort()" class="cursorPointer"> 75% Completed </span>
				</ng-template>
				<ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
					<div class="other-stats" [title]="row['formatted_75_completions_rate']">
						{{ row['formatted_75_completions_rate'] }}
					</div>
				</ng-template>
				<ng-template let-colHeader="column" let-sort="sortFn" ngx-datatable-header-template>
					<span class="datatable-header-cell-wrapper">
						<span (click)="sort()" class="cursorPointer"> 75% Completed </span>
					</span>
				</ng-template>
			</ngx-datatable-column>
			<ngx-datatable-column name="hundredpercent" [comparator]="percent100Comparator" [resizeable]="false">
				<ng-template let-colHeader="column" let-sort="sortFn" ngx-datatable-header-template>
					<span (click)="sort()" class="cursorPointer"> 100% Completed </span>
				</ng-template>
				<ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
					<div class="other-stats" [title]="row['formatted_100_completions_rate']">
						{{ row['formatted_100_completions_rate'] }}
					</div>
				</ng-template>
				<ng-template let-colHeader="column" let-sort="sortFn" ngx-datatable-header-template>
					<span class="datatable-header-cell-wrapper">
						<span (click)="sort()" class="cursorPointer"> 100% Completed </span>
					</span>
				</ng-template>
			</ngx-datatable-column>
		</ngx-datatable>
	</div>
</div>
